/* eslint-disable @next/next/no-img-element */
import { FC, useCallback } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Theme } from '@mui/material/styles';
import { css } from '@mildang/styled-system/css';
import loginFormBg from './assets/loginFormBg.png';
import loginFormBgTablet from './assets/loginFormBg_tablet.png';

const imgStyle = css({
  maxWidth: '400px',
});

interface IWelcomeBackgroundImageProps {
  className?: string;
}
const WelcomeBackgroundImage: FC<IWelcomeBackgroundImageProps> = (props) => {
  const isMdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const isSmDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const imageElRef = useCallback<(el: HTMLImageElement) => void>(
    (node) => {
      if (node) {
        if (isSmDown) {
          return;
        }
        if (!node.animate) {
          return;
        }
        try {
          node.animate([{ transform: 'scale(1.8)' }], {
            fill: 'forwards',
            easing: 'cubic-bezier(0, 0, 0.1, 1)',
            duration: 500,
          });
        } catch (e) {
          console.error(e);
        }
      }
    },
    [isSmDown],
  );

  return (
    <div
      {...props}
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      }}
    >
      {/* TODO: use next/image */}
      <img
        ref={imageElRef}
        className={imgStyle}
        // @ts-ignore
        src={isMdDown ? loginFormBgTablet.src : loginFormBg.src}
        alt="밀당PT 환영 배경"
      />
    </div>
  );
};

export default WelcomeBackgroundImage;
